module.exports = __webpack_public_path__ + "src/assets/es.45276403.png";